<app-nav-bar></app-nav-bar>

<router-outlet></router-outlet>

<app-global-error-modal></app-global-error-modal>

<router-outlet name="modal"></router-outlet>

<div id="popupOverlay" class="popup-overlay" (click)="closeZeffyPopup($event)">
  <div class="popup-content">
    <button type="button" class="popup-close" aria-label="Close donation popup" data-close-popup="true"
      (click)="closeZeffyPopup()">
      &times;
    </button>
    <div class="popup-header">
      <span class="popup-eyebrow">{{ zeffyPopupContent().eyebrow }}</span>
    </div>
    <iframe id="zeffyDonationFrame" [attr.data-src]="zeffyPopupContent().url" allow="payment"
      [attr.title]="zeffyPopupContent().iframeTitle"></iframe>
  </div>
</div>

<app-footer></app-footer>